import { render, staticRenderFns } from "./y-button.vue?vue&type=template&id=6211fe7f&"
import script from "./y-button.vue?vue&type=script&lang=js&"
export * from "./y-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports